// Parse a human event date string (e.g. "October 5, 2026", "Feb 14–16, 2026")
// and decide whether the event is still upcoming. Unknown/unparseable dates
// are treated as upcoming so valid events are never hidden.
export function parseEventDate(ev) {
  const raw = (ev?.date || "").trim();
  if (!raw) return null;
  let first = raw.split(/[–—]|\s-\s/)[0].trim();
  const yearMatch = raw.match(/\b(20\d{2})\b/);
  const year = yearMatch ? yearMatch[1] : String(new Date().getFullYear());
  if (!/\d{4}/.test(first)) first = `${first}, ${year}`;
  const d = new Date(first);
  return isNaN(d.getTime()) ? null : d;
}

export function isFutureEvent(ev) {
  const d = parseEventDate(ev);
  if (!d) return true;
  const today = new Date();
  today.setHours(0, 0, 0, 0);
  return d >= today;
}
